module.exports = __webpack_public_path__ + "img/invoice.5e3e3ba2.svg";